import callPhoneNumber from "./callPhoneNumber"
import dialNumber from "./dialNumber"

export const phone = { dialNumber, callNumber: callPhoneNumber }
export { dialNumber };

